// https://app.asana.com/0/1187182828763289/1202893405173477/f
// If the export is not a JSON string - Safari crashes applying the effect
export default {
  blush: {
    matte: {
      A: 0.5,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 0.8,
        mid: 0.6,
        low: 0.4,
      },
    },
    shimmer: {
      A: 1.0,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 0.8,
        mid: 0.6,
        low: 0.4,
      },
    },
    cream_shine: {
      A: 1,
      C: 1.3,
      R: 1,
      P: -1,
      K: {
        high: 0.8,
        mid: 0.6,
        low: 0.4,
      },
    },
  },
  concealer: {
    natural: {
      A: 1,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 0.4,
        mid: 0.3,
        low: 0.2,
      },
    },
    matte: {
      A: 0.5,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.6,
        low: 0.4,
      },
    },
  },
  contour: {
    normal: {
      A: 1,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.6,
      },
    },
  },
  eyebrows: {
    matte: {
      A: 1,
      C: 0.5,
      R: 1,
      P: -1,
      K: {
        high: 0.5,
        mid: 0.4,
        low: 0.3,
      },
    },
    wet: {
      A: 1.5,
      C: 1.5,
      R: 1,
      P: -1,
      K: {
        high: 0.5,
        mid: 0.4,
        low: 0.3,
      },
    },
    clear: {
      A: 1,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 0.5,
        mid: 0.4,
        low: 0.3,
      },
    },
  },
  eyelashes: {
    volume: {
      texture: "textures/eyelashes/lashes_tex4.ktx",
      length: 1.3,
      K: {
        high: 0.85,
        mid: 0.75,
      },
    },
    lengthening: {
      texture: "textures/eyelashes/lashes_tex1.ktx",
      length: 1.3,
      K: {
        high: 0.85,
        mid: 0.75,
      },
    },
    lengthandvolume: {
      texture: "textures/eyelashes/lashes_tex6.ktx",
      length: 1.3,
      K: {
        high: 0.85,
        mid: 0.75,
      },
    },
    natural: {
      texture: "textures/eyelashes/lashes_tex3.ktx",
      length: 1.3,
      K: {
        high: 0.85,
        mid: 0.75,
      },
    },
    natural_bottom: {
      texture: "textures/eyelashes/lashes_tex5.ktx",
      length: 1.3,
      K: {
        high: 0.85,
        mid: 0.75,
      },
    },
  },
  eyeliner: {
    cream: {
      A: 1,
      C: 1.0,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_liquid: {
      A: 1,
      C: 0.6,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_cream: {
      A: 1,
      C: 0.6,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    metallic: {
      A: 1.0,
      C: 1.0,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    shimmer: {
      A: 1.0,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    glitter: {
      A: 1.0,
      C: 1.0,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    cream_lightcolors: {
      A: 1.0,
      C: 0.6,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
  },
  eyeshadow: {
    matte: {
      A: 0.5,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.9,
        low: 0.8,
      },
    },
    matte_powder: {
      A: 0.5,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.9,
        low: 0.8,
      },
    },
    shimmer: {
      A: 1.0,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.9,
        low: 0.8,
      },
    },
    glitter_metallic: {
      A: 1.3,
      C: 1.3,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.9,
        low: 0.8,
      },
    },
    glitter: {
      A: 1.3,
      C: 1.0,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.9,
        low: 0.8,
      },
    },
    metallic: {
      A: 1.3,
      C: 1.3,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.9,
        low: 0.8,
      },
    },
    glitter_sheer: {
      A: 1.0,
      C: 1.3,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.9,
        low: 0.8,
      },
    },
    cream: {
      A: 1,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.9,
        low: 0.8,
      },
    },
  },
  foundation: {
    matte: {
      A: 0.5,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 0.8,
        mid: 0.6,
        low: 0.4,
      },
    },
    natural: {
      A: 1,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 0.8,
        mid: 0.6,
        low: 0.4,
      },
    },
    radiance: {
      A: 1,
      C: 1.3,
      R: 0,
      P: 0,
      K: {
        high: 0.8,
        mid: 0.6,
        low: 0.4,
      },
    },
  },
  powder: {
    matte: {
      A: 0.5,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 0.8,
        mid: 0.6,
        low: 0.4,
      },
    },
    natural: {
      A: 1,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 0.8,
        mid: 0.6,
        low: 0.4,
      },
    },
    radiance: {
      A: 1,
      C: 1.3,
      R: 0,
      P: 0,
      K: {
        high: 0.8,
        mid: 0.6,
        low: 0.4,
      },
    },
  },
  highlighter: {
    shimmer: {
      A: 1.2,
      C: 1.2,
      R: 1,
      P: -1,
      K: {
        high: 0.6,
        mid: 0.5,
        low: 0.4,
      },
    },
  },
  lipsliner: {
    shimmer: {
      A: 1.2,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
  },
  lipstick: {
    matte_dry: {
      A: 0.5,
      C: 1.0,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_cream: {
      A: 0.5,
      C: 1.1,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_powder: {
      A: 0.7,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_liquid: {
      A: 0.5,
      C: 1.1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    cream_shine: {
      A: 1.0,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    glossy_cream_plumping: {
      A: 1.0,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    balm: {
      A: 1,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    glossy_cream_shimmer: {
      A: 1.2,
      C: 1.2,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    cream_vividcolors: {
      A: 1,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_velvet: {
      A: 0.5,
      C: 1,
      R: 2,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    cream_shine_glitter: {
      A: 1.5,
      C: 1.2,
      R: 2,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    shimmer: {
      A: 1.2,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_velvet_sparkling: {
      A: 0.5,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_sheer_lightcolors: {
      A: 0.5,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_cream_vividcolors: {
      A: 0.8,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    metallic_cream: {
      A: 1.2,
      C: 1.2,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_velvet_sparkling_lightcolors: {
      A: 0.5,
      C: 1,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    matte_light: {
      A: 0.5,
      C: 1,
      R: 0,
      P: 0,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    metallic_shine: {
      A: 1.2,
      C: 1.2,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    metallic_dry_lightcolors: {
      A: 1.2,
      C: 1.2,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    satin: {
      A: 1.2,
      C: 1.2,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
    shine: {
      A: 1.3,
      C: 1.3,
      R: 1,
      P: -1,
      K: {
        high: 1,
        mid: 0.8,
        low: 0.7,
      },
    },
  },
}
